import { isNonNullable } from "../utils/isNonNullable";
const TypographyControlType = "makeswift::controls::typography";
function unstable_Typography() {
  return {
    type: TypographyControlType
  };
}
function getTypographySwatchIds(value) {
  return value?.style.flatMap((style) => style.value.color?.swatchId ?? []).filter(isNonNullable) ?? [];
}
function getTypographyTypographyIds(value) {
  return [value?.id].filter(isNonNullable);
}
export {
  TypographyControlType,
  getTypographySwatchIds,
  getTypographyTypographyIds,
  unstable_Typography
};
//# sourceMappingURL=typography.js.map